export enum ChallengeType {
    MFA = 'MFA',
    MFA_CONFIG = 'MFAConfig',
    DEVICE_VERIFICATION = 'DeviceVerification',
    TERMS_ACCEPTANCE = 'TermsAcceptance',
    PASSWORD_CHANGE = 'PasswordChange',
}
